// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `commercials-overview {
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
  /* If you want text inside of the container */
}
commercials-overview mat-card-header {
  background-color: rgba(247, 247, 247, 0.5411764706);
}
commercials-overview fuse-sidebar.properties-panel {
  width: 90%;
  min-width: 90%;
  max-width: 90%;
}
commercials-overview .mainDiv {
  width: 100%;
}
commercials-overview .SaleRent {
  color: #0000FF;
  font-weight: bold;
}
commercials-overview .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
commercials-overview .iframeContainer {
  width: 100%;
  padding-top: 100%;
  /* 1:1 Aspect Ratio */
  position: relative;
}
commercials-overview iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
commercials-overview .image {
  max-width: 100% !important;
  max-height: 100% !important;
  width: auto !important;
  height: auto !important;
}
commercials-overview .card-content {
  min-height: 400px;
  max-height: 400px;
}
commercials-overview .active {
  background-color: #FF9300;
}
commercials-overview .lower-diagonal-active {
  background: linear-gradient(to right bottom, #ffffff 50%, #FF9300 50%);
}
commercials-overview .upper-diagonal-active {
  background: linear-gradient(to right bottom, #FF9300 50%, #ffffff 50%);
}
commercials-overview .blocked {
  background-color: #919191;
}
commercials-overview .greenColor {
  background-color: #27c24c;
}
commercials-overview .lower-diagonal-green {
  background: linear-gradient(to right bottom, #ffffff 50%, #27c24c 50%);
}
commercials-overview .upper-diagonal-green {
  background: linear-gradient(to right bottom, #27c24c 50%, #ffffff 50%);
}
commercials-overview .fully-paid {
  background-color: #23b7e5;
}
commercials-overview .lower-diagonal-fully-paid {
  background: linear-gradient(to right bottom, #ffffff 50%, #23b7e5 50%);
}
commercials-overview .upper-diagonal-fully-paid {
  background: linear-gradient(to right bottom, #23b7e5 50%, #ffffff 50%);
}
commercials-overview .on-hold {
  background-color: #915d1a;
}
commercials-overview .lower-diagonal-on-hold {
  background: linear-gradient(to right bottom, #ffffff 50%, #915d1a 50%);
}
commercials-overview .upper-diagonal-on-hold {
  background: linear-gradient(to right bottom, #915d1a 50%, #ffffff 50%);
}
commercials-overview .map-container {
  height: 100% !important;
  width: 100% !important;
}

fuse-sidebar.properties-panel {
  width: 90%;
  min-width: 90%;
  max-width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/app/main/commercials/commercials-view/commercials-overview/commercials-overview.component.scss"],"names":[],"mappings":"AAAA;EACI,2HAAA;EA0CA,6CAAA;AAxCJ;AADI;EACI,mDAAA;AAGR;AACQ;EACI,UAAA;EACA,cAAA;EACA,cAAA;AACZ;AAGI;EACI,WAAA;AADR;AAII;EACI,cAAA;EACA,iBAAA;AAFR;AAKI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAMI;EACI,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAJR;AAQI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AANR;AASI;EACI,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAPR;AASI;EACI,iBAAA;EACA,iBAAA;AAPR;AASI;EACI,yBAAA;AAPR;AAUI;EACI,sEAAA;AARR;AAWI;EACI,sEAAA;AATR;AAYI;EACI,yBAAA;AAVR;AAaI;EACI,yBAAA;AAXR;AAcI;EACI,sEAAA;AAZR;AAeI;EACI,sEAAA;AAbR;AAgBI;EACI,yBAAA;AAdR;AAiBI;EACI,sEAAA;AAfR;AAkBI;EACI,sEAAA;AAhBR;AAmBI;EACI,yBAAA;AAjBR;AAmBI;EACI,sEAAA;AAjBR;AAmBI;EACI,sEAAA;AAjBR;AAmBI;EACI,uBAAA;EACA,sBAAA;AAjBR;;AAsBI;EACI,UAAA;EACA,cAAA;EACA,cAAA;AAnBR","sourcesContent":["commercials-overview {\n    /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\n    mat-card-header {\n        background-color: #f7f7f78a;\n    }\n\n    fuse-sidebar {\n        &.properties-panel {\n            width: 90%;\n            min-width: 90%;\n            max-width: 90%;\n        }\n    }\n\n    .mainDiv {\n        width: 100%;\n    }\n\n    .SaleRent {\n        color: #0000FF;\n        font-weight: bold;\n    }\n\n    .loading-shade {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.15);\n        z-index: 1000;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .iframeContainer {\n        width: 100%;\n        padding-top: 100%;\n        /* 1:1 Aspect Ratio */\n        position: relative;\n    }\n\n    /* If you want text inside of the container */\n    iframe {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n    }\n\n    .image {\n        max-width: 100% !important;\n        max-height: 100% !important;\n        width: auto !important;\n        height: auto !important;\n    }\n    .card-content{\n        min-height: 400px;\n        max-height: 400px;\n    }\n    .active {\n        background-color: #FF9300;\n    }\n\n    .lower-diagonal-active {\n        background: linear-gradient(to right bottom, #ffffff 50%, #FF9300 50%);\n    }\n\n    .upper-diagonal-active {\n        background: linear-gradient(to right bottom, #FF9300 50%, #ffffff 50%);\n    }\n\n    .blocked {\n        background-color: #919191;\n    }\n\n    .greenColor {\n        background-color: #27c24c;\n    }\n\n    .lower-diagonal-green {\n        background: linear-gradient(to right bottom, #ffffff 50%, #27c24c 50%);\n    }\n\n    .upper-diagonal-green {\n        background: linear-gradient(to right bottom, #27c24c 50%, #ffffff 50%);\n    }\n\n    .fully-paid {\n        background-color: #23b7e5;\n    }\n\n    .lower-diagonal-fully-paid {\n        background: linear-gradient(to right bottom, #ffffff 50%, #23b7e5 50%);\n    }\n\n    .upper-diagonal-fully-paid {\n        background: linear-gradient(to right bottom, #23b7e5 50%, #ffffff 50%);\n    }\n\n    .on-hold {\n        background-color: #915d1a;\n    }\n    .lower-diagonal-on-hold {\n        background: linear-gradient(to right bottom, #ffffff 50%, #915d1a 50%);\n    }\n    .upper-diagonal-on-hold {\n        background: linear-gradient(to right bottom, #915d1a 50%, #ffffff 50%);\n    }\n    .map-container{\n        height: 100% !important;\n        width: 100% !important;\n    }\n}\n\nfuse-sidebar {\n    &.properties-panel {\n        width: 90%;\n        min-width: 90%;\n        max-width: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
